<template>
  <form>
    <div class="row">
      <div class="col-lg-9">
        <div class="row">
          <div class="col-lg-12">
            <h4 class="card-title font-weight-bold">{{$t('medium_grant_ev.esms__summary_title')}}</h4>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-11">
            <table class="table-full-width table-bordered border-left-0 border-top-0 border-bottom-0 border-right-0">
              <tr>
                <td class="border-left-0 border-top-0">
                  <h5 class="card-title font-weight-bold mb-0">{{$t('medium_grant_ev.esms__rationale')}}</h5>
                  <h5 class="card-title">{{$t('medium_grant_ev.esms__rationale_sub')}}</h5>
                </td>
                <td class="border-top-0 border-right-0" colspan="2">
                  <base-input>
      <textarea
        class="form-control mt-5"
        :placeholder="$t('general.write_here')"
        v-model="EvaluationForm.model.rationale"
      >
      </textarea>
                  </base-input>
                </td>
              </tr>

              

              <tr>
                <td class="border-left-0 border-right-0" colspan="2">
                  <h5 class="card-title font-weight-bold mt-3 mb-3">{{$t('medium_grant_ev.esms__required_actions_for_right')}}</h5>
                </td>
              </tr>

              <tr>
                <td class="border-left-0">
                  <h5 class="card-title font-weight-bold mt-3">{{$t('medium_grant_ev.esms__esms_standards')}}</h5>
                </td>
                <td class="pl-2">
                  <h5 class="card-title font-weight-bold mt-3">{{$t('medium_grant_ev.esms__trigger')}}</h5>
                </td>
                <td class="border-right-0 pl-2">
                  <h5 class="card-title font-weight-bold mt-3">{{$t('medium_grant_ev.esms__required_tools_plans')}}</h5>
                </td>
              </tr>
              <tr>
                <td class="border-left-0">
                  <h5 class="card-title font-weight-bold mt-3">{{$t('medium_grant_ev.esms__involuntary_resettlement')}}</h5>
                </td>
                <td class="pl-2">
                  <div class="pt-3 pb-3">
                    <radio name="model.involuntary_resettlement_trigger"
                           inline
                           value="yes"
                           v-model="EvaluationForm.model.involuntary_resettlement_trigger"
                    >
                      {{$t('medium_grant_ev.general__yes')}}
                    </radio>
                    <radio name="model.involuntary_resettlement_trigger" inline value="no" v-model="EvaluationForm.model.involuntary_resettlement_trigger">
                      {{$t('medium_grant_ev.general__no')}}
                    </radio>
                    <radio name="model.involuntary_resettlement_trigger" inline value="tbd" v-model="EvaluationForm.model.involuntary_resettlement_trigger">
                      {{$t('medium_grant_ev.general__tbd')}}
                    </radio>
                  </div>
                </td>
                <td class="border-right-0 pl-2">
                  <div class="pt-3 pb-3">
                    <radio name="model.involuntary_resettlement_plan"
                           inline
                           value="1"
                           v-model="EvaluationForm.model.involuntary_resettlement_plan"
                    >
                      {{$t('medium_grant_ev.esms__involuntary_resettlement_aplan')}}
                    </radio>
                    <radio name="model.involuntary_resettlement_plan" inline value="2" v-model="EvaluationForm.model.involuntary_resettlement_plan">
                      <!--{{$t('medium_grant_ev.esms__involuntary_policy_framework')}}-->
                      {{$t('medium_grant_ev.esms__involuntary_process_framework')}}
                    </radio>
                    <radio name="model.involuntary_resettlement_plan" inline value="3" v-model="EvaluationForm.model.involuntary_resettlement_plan">
                      {{$t('medium_grant_ev.esms__involuntary_action_plan_mitigate')}}
                    </radio>
                  </div>
                </td>
              </tr>

              <tr>
                <td class="border-left-0">
                  <h5 class="card-title font-weight-bold mt-3">{{$t('medium_grant_ev.esms__indigenous_people')}}</h5>
                </td>
                <td class="pl-2">
                  <div class="pt-3 pb-3">
                    <radio name="model.indigenous_trigger"
                           inline
                           value="yes"
                           v-model="EvaluationForm.model.indigenous_trigger"
                    >
                      {{$t('medium_grant_ev.general__yes')}}
                    </radio>
                    <radio name="model.indigenous_trigger" inline value="no" v-model="EvaluationForm.model.indigenous_trigger">
                      {{$t('medium_grant_ev.general__no')}}
                    </radio>
                    <radio name="model.indigenous_trigger" inline value="tbd" v-model="EvaluationForm.model.indigenous_trigger">
                      {{$t('medium_grant_ev.general__tbd')}}
                    </radio>
                  </div>
                </td>
                <td class="border-right-0 pl-2">
                  <div class="pt-3 pb-3">
                    <radio name="model.indigenous_plan"
                           inline
                           value="1"
                           v-model="EvaluationForm.model.indigenous_plan"
                    >
                      {{$t('medium_grant_ev.esms__indigenous_plan_1')}}
                    </radio>
                    <radio name="model.indigenous_plan" inline value="2" v-model="EvaluationForm.model.indigenous_plan">
                      {{$t('medium_grant_ev.esms__indigenous_plan_2')}}
                    </radio>
                  </div>
                </td>
              </tr>

              <tr>
                <td class="border-left-0">
                  <h5 class="card-title font-weight-bold mt-3">{{$t('medium_grant_ev.esms__cultural_heritage')}}</h5>
                </td>
                <td class="pl-2">
                  <div class="pt-3 pb-3">
                    <radio name="model.cultural_trigger"
                           inline
                           value="yes"
                           v-model="EvaluationForm.model.cultural_trigger"
                    >
                      {{$t('medium_grant_ev.general__yes')}}
                    </radio>
                    <radio name="model.cultural_trigger" inline value="no" v-model="EvaluationForm.model.cultural_trigger">
                      {{$t('medium_grant_ev.general__no')}}
                    </radio>
                    <radio name="model.cultural_trigger" inline value="tbd" v-model="EvaluationForm.model.cultural_trigger">
                      {{$t('medium_grant_ev.general__tbd')}}
                    </radio>
                  </div>
                </td>
                <td class="border-right-0 pl-2">
                  <div class="pt-3 pb-3">
                    <radio name="model.cultural_plan"
                           inline
                           value="1"
                           v-model="EvaluationForm.model.cultural_plan"
                    >
                      {{$t('medium_grant_ev.esms__cultural_plan_1')}}
                    </radio>
                  </div>
                </td>
              </tr>

              <tr>
                <td class="border-left-0 border-bottom-0">
                  <h5 class="card-title font-weight-bold mt-3">{{$t('medium_grant_ev.esms__biodiversity')}}</h5>
                </td>
                <td class="pl-2 border-bottom-0">
                  <div class="pt-3 pb-3">
                    <radio name="model.biodiversity_trigger"
                           inline
                           value="yes"
                           v-model="EvaluationForm.model.biodiversity_trigger"
                    >
                      {{$t('medium_grant_ev.general__yes')}}
                    </radio>
                    <radio name="model.biodiversity_trigger" inline value="no" v-model="EvaluationForm.model.biodiversity_trigger">
                      {{$t('medium_grant_ev.general__no')}}
                    </radio>
                    <radio name="model.biodiversity_trigger" inline value="tbd" v-model="EvaluationForm.model.biodiversity_trigger">
                      {{$t('medium_grant_ev.general__tbd')}}
                    </radio>
                  </div>
                </td>
                <td class="border-right-0 border-bottom-0 pl-2">
                  <div class="pt-3 pb-3">
                    <radio name="model.biodiversity_plan"
                           inline
                           value="1"
                           v-model="EvaluationForm.model.biodiversity_plan"
                    >
                      {{$t('medium_grant_ev.esms__biodiversity_plan_1')}}
                    </radio>
                  </div>
                </td>
              </tr>

              <tr>
                <td class="border-left-0">
                  <h5 class="card-title font-weight-bold">Others</h5>
                </td>
                <td class="pl-2">
                  <div class="pt-3 pb-3">
                    <radio name="model.others_trigger"
                           inline
                           value="yes"
                           v-model="EvaluationForm.model.others_trigger"
                    >
                      {{$t('medium_grant_ev.general__yes')}}
                    </radio>
                    <radio name="model.others_trigger" inline value="no" v-model="EvaluationForm.model.others_trigger">
                      {{$t('medium_grant_ev.general__no')}}
                    </radio>
                    <radio name="model.others_trigger" inline value="tbd" v-model="EvaluationForm.model.others_trigger">
                      {{$t('medium_grant_ev.general__tbd')}}
                    </radio>
                  </div>
                </td>
                <td class="border-right-0 pl-2">
                  <div class="pt-3 pb-3"
                  :key="Update"
                   @change="showOtherText()">

                    <radio name="required_assesment" inline value="1" v-model="EvaluationForm.model.required_assesment">
                      {{$t('medium_grant_ev.esms__required_full_environmental')}}
                    </radio>
                    <radio name="required_assesment" inline value="2" v-model="EvaluationForm.model.required_assesment">
                      {{$t('medium_grant_ev.esms__required_partial_environmental')}}
                    </radio>
                    <radio name="required_assesment" inline value="3" v-model="EvaluationForm.model.required_assesment">
                      {{$t('medium_grant_ev.esms__required_social_impact')}}
                    </radio>
                    <radio name="required_assesment" inline value="4" v-model="EvaluationForm.model.required_assesment">
                      {{$t('medium_grant_ev.esms__required_esmp')}}
                    </radio>
                    <radio name="required_assesment" inline value="5" v-model="EvaluationForm.model.required_assesment">
                      {{$t('medium_grant_ev.esms__required_esmf')}}
                    </radio>
                    <radio name="required_assesment" inline value="6" v-model="EvaluationForm.model.required_assesment">
                      {{$t('medium_grant_ev.esms__required_other')}}
                    </radio>
                    <!--<button class="btn lf-modal-remove-indicator" @click="showOtherText()">Enter document name</button>-->
                    <div v-show="EvaluationForm.model.required_assesment == 6">
                      <p>Name of the document</p>
                      <textarea
                        class="form-control mt-5"
                        :placeholder="$t('general.write_here')"
                        v-model="EvaluationForm.model.nameofdocument"
                      >
                      </textarea>
                    </div>
                    
                  </div>
                  
                  
                </td>
              </tr>
            </table>
          </div>
        </div>

      </div>
      <div class="col-lg-3">
        <info-right></info-right>
      </div>
    </div>
  </form>
</template>
<script>
  import {EvaluationForm} from "@/services";
  import InfoRight from './InfoRight';
  import {CommentBox} from 'src/components';

  export default {
    components: {
      InfoRight,
      CommentBox
    },
    data() {
      return {
        EvaluationForm,
        Update:0
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      },
      showOtherText(){
        this.Update+=1;
        //this.$forceUpdate();
      }
      
    }
  }
</script>